import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTriangleLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.8716 19.0335C17.3716 19.3257 18 18.9651 18 18.386L18 5.614C18 5.03489 17.3716 4.67427 16.8716 4.96648L6.09215 11.2661C5.53066 11.5943 5.53066 12.4057 6.09215 12.7339L16.8716 19.0335ZM19.5 18.386C19.5 20.1233 17.6147 21.2052 16.1147 20.3286L5.3353 14.0289C3.78294 13.1217 3.78294 10.8783 5.3353 9.97108L16.1147 3.67142C17.6147 2.79481 19.5 3.87667 19.5 5.61401L19.5 18.386Z",
		fill: "currentColor"
	})
});
export { SvgIconTriangleLeft as ReactComponent };
